import { render } from "./AIAgentTraining.vue?vue&type=template&id=5b3b2eef&scoped=true"
import script from "./AIAgentTraining.vue?vue&type=script&lang=js"
export * from "./AIAgentTraining.vue?vue&type=script&lang=js"

import "./AIAgentTraining.vue?vue&type=style&index=0&id=5b3b2eef&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3b2eef"]])

export default __exports__